import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  modalContent: {
    maxH: { base: '100vh', md: '96vh' },
    overflow: 'auto',
  },
  plotMapWrapper: {
    height: { base: '300px', md: '320px' },
  },
  formContainer: {
    mt: { base: '12', md: '24px' },
  },
  hStack: {
    pb: '16px',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  controllerContainer: {
    flexDirection: { base: 'column', sm: 'row' },
    gap: '20px',
    width: '100%',
    alignItems: 'flex-start',
  },
  findPlotBtn: {
    width: { base: '100%', sm: '48%' },
    marginTop: { base: '0px', sm: '-5px' },
    flexShrink: 0,
  },
  btnSitePlan: {
    fontSize: '1.4rem',
    textTransform: 'none',
    placeItems: 'center',
    gap: '5px',
    ml: '15px',
  },
  infoNotFoundBox: {
    my: { base: '12px', md: '24px' },
  },
  loaderBox: {
    display: 'flex',
    alignItems: 'center',
    minH: '145px',
    mt: '24px',
  },
});
export default style;
